import { Fragment } from "react";

export const RootProvider = ({
  children,
}: JSX.ElementChildrenAttribute): JSX.Element => {
  return <Fragment>{children}</Fragment>;
};
